class PurchaseOrderSearchController extends BaseSearchController
	@register angular.module 'App.Module.Controller'
	@inject '$filter',
		'$q'
		'PURCHASE_ORDER'
		'SuppliersRepository'

	applySearchFilter: (query) ->
		super(query)

		query.sortBy 'expected_delivery_time', 'DESC'

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'status'
			statuses = []

			for status of @PURCHASE_ORDER.STATUS
				if status == 'NEW'
					continue

				statuses.push({
					id: status,
					name: @$filter('translate')('general.purchase_order.status.' + status.toLowerCase())
				})

			return @$q.when(statuses)

		return super(filterKey)
